// apps/web/src/hooks/useAuth.ts
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { api } from '../lib/api';
import type { User } from '@hc-alumni/shared/types';

interface AuthState {
  user: User | null;
  loading: boolean;
  fetchMe: () => Promise<void>;
  login: (code: string, state: string) => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: User | null) => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      loading: true,

      fetchMe: async () => {
        try {
          const { user } = await api.auth.me();
          set({ user, loading: false });
        } catch {
          set({ user: null, loading: false });
        }
      },

      login: async (code: string, state: string) => {
        const { user } = await api.auth.lineCallback(code, state);
        // 登入成功立刻標記完成，讓「加入校友會」浮鈕／橫幅立即消失
        set({ user, loading: false });
      },

      logout: async () => {
        await api.auth.logout();
        set({ user: null, loading: false });
      },

      setUser: (user) => set({ user }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => sessionStorage), // 只在 session 中持久化
      partialize: (state) => ({ user: state.user }), // 不持久化 loading
    }
  )
);

// 初始化時自動獲取用戶資訊
if (typeof window !== 'undefined') {
  useAuth.getState().fetchMe();
}